<div class="card mt-4">
  <div class="card-header text-center"><small><b>O-Ring Options</b></small></div>
  <div class="card-body">
    <ng-template #loader>
      <app-loader *ngIf="(showLoader$ | async)"></app-loader>
    </ng-template>
    <ng-container *ngIf="!(showLoader$ | async) else loader">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th><small>Part Number</small></th>
          <th><small>Material</small></th>
          <th><small>Temp. Range</small></th>
          <th><small>Durometer</small></th>
          <th><small>Sellable WH/EH</small></th>
        </tr>
      </thead>
      <tbody>
        <tr [ngStyle]="{
            'font-weight': item.sellableWH === 'PPN' 
                            || item.sellableWH === 'REC' 
                          ? 'bold' 
                          : 'normal',
            'font-style': item.sellableWH === 'PPN' 
                                ? 'italic'
                                : 'none' 
            }" 
            *ngFor="let item of filteredProducts$ | async">
          <td><span class="ms-2"><small>{{item.partNumber}}</small></span></td>
          <td><span class="ms-2"><small>{{item.materialName}}</small></span></td>
          <td><span class="me-2"><small>{{ item | oringTempRange}}</small></span></td>
          <td><span class="ms-2"><small>{{item.durometer}}</small></span></td>
          <td><span class="ms-2"><small>{{item.sellableWH ?? 'ETO'}}/{{item.sellableEH ?? 'ETO'}}</small></span></td>
        </tr>
      </tbody>
    </table>
  </ng-container>
  </div>
</div>
